import report from './landingpage.report.store';

export default {
    namespaced: true,
    modules: {
        report
    }
};
